import styled from "styled-components";
import { Type } from "@ebscois/react-component-library";

export const ButtonWrapper = styled.div`
  & > *:not(:first-child) {
    margin-left: ${({ theme }) => theme.space.md};
  }
`;

export const CallToActionContainer = styled.div`
  margin: ${({ theme }) => `0 ${theme.space.xxxl} ${theme.space.lg}`};
  text-align: center;
  & > *:not(:last-child) {
    margin-bottom: 0.75rem;
  }
`;

export const PrimaryMessageLeadIn = styled(Type)`
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin-bottom: ${({ theme }) => theme.space.md};
  }
`;
